import { render, staticRenderFns } from "./SliceProfilePage.vue?vue&type=template&id=69b67e0f&"
import script from "./SliceProfilePage.vue?vue&type=script&lang=js&"
export * from "./SliceProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports